import {styled, InputLabel, Stack} from '@mui/material'

export const ButtonsWrapper = styled(Stack)(() => ({
  gap: '1rem',
  paddingRight: '3rem',
  paddingTop: '2rem',
  maxWidth: 250,
}))

export const Label = styled(InputLabel)(({theme}) => ({
  textAlign: 'start',
  color: theme.palette.grey[100],
  ...theme.typography.body2,
}))

export const pdfViewStyle = {border: 'none'}
